module.exports = __webpack_public_path__ + "media/images/disable_camera_pause-27308ebef8e28c36c2911920de1839dc.svg";